// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1dPx8","icon":"SortAdornment_icon__3M17j","up":"SortAdornment_up__H_QxU","down":"SortAdornment_down__ZWF_W","active":"SortAdornment_active__1jlG_"};